import {PageRequest} from '../core/pagination/page-request';
import {SortOrder} from '../core/sort/sort-order';
import {Activiteit, VerwerkingsStatus} from './activiteit';

export class ActiviteitPageRequest extends PageRequest<Activiteit> {

  static firstActiviteitenPageRequest(verwerkingsStatus: VerwerkingsStatus, sortOrder: SortOrder, pageSize: number): ActiviteitPageRequest {
    return new ActiviteitPageRequest(
      sortOrder === SortOrder.ASCENDING,
      pageSize,
      1,
      0,
      verwerkingsStatus,
    );
  }

  constructor(
    ascending: boolean,
    pageSize: number,
    pageNumber: number,
    previousPageNumber: number,
    public verwerkingsStatus: VerwerkingsStatus,
    public clientZones?: string[],
    public clientDiensten?: string[],
    firstItemPreviousPage?: Activiteit,
    lastItemPreviousPage?: Activiteit,
  ) {
    super(ascending, pageSize, pageNumber, previousPageNumber, firstItemPreviousPage, lastItemPreviousPage);
  }

  withSortOrder(sortOrder: SortOrder): ActiviteitPageRequest {
    return this.forPageRequest(ActiviteitPageRequest.firstActiviteitenPageRequest(this.verwerkingsStatus, sortOrder, this.getPageSize()));
  }

  withPageSize(pageSize: number): ActiviteitPageRequest {
    return this.forPageRequest(ActiviteitPageRequest.firstActiviteitenPageRequest(this.verwerkingsStatus, this.getSortOrder(), pageSize));
  }

  withZoneId(zoneId: string[]): ActiviteitPageRequest {
    return new ActiviteitPageRequest(
      this.ascending,
      this.pageSize,
      1,
      0,
      this.verwerkingsStatus,
      zoneId
    );
  }

  withDienstId(dienstIds: string[]): ActiviteitPageRequest {
    return new ActiviteitPageRequest(
      this.ascending,
      this.pageSize,
      1,
      0,
      this.verwerkingsStatus,
      dienstIds
    );
  }
  withZoneIdAndDienstId(zoneIds: string[], dienstIds: string[]): ActiviteitPageRequest {
    return new ActiviteitPageRequest(
      this.ascending,
      this.pageSize,
      1,
      0,
      this.verwerkingsStatus,
      zoneIds,
      dienstIds
    );
  }
  withVerwerkingsStatus(verwerkingsStatus: VerwerkingsStatus, sortOrder: SortOrder): ActiviteitPageRequest {
    return new ActiviteitPageRequest(
      sortOrder === SortOrder.ASCENDING,
      this.pageSize,
      1,
      0,
      verwerkingsStatus,
      this.clientZones,
      this.clientDiensten
    );
  }

  toFirstPage(): ActiviteitPageRequest {
    return this.forPageRequest(ActiviteitPageRequest.firstActiviteitenPageRequest(this.verwerkingsStatus, this.getSortOrder(), this.getPageSize()));
  }

  forPageRequest(pageRequest: PageRequest<Activiteit>): ActiviteitPageRequest {
    return new ActiviteitPageRequest(
      pageRequest.ascending,
      pageRequest.pageSize,
      pageRequest.pageNumber,
      pageRequest.previousPageNumber,
      this.verwerkingsStatus,
      this.clientZones,
      this.clientDiensten,
      pageRequest.firstItemPreviousPage,
      pageRequest.lastItemPreviousPage,
    );
  }
}
